import { API_URL_MEDIA } from "@constants/env";
import apiInstance from "@services/Shared/instanceAxios";

const getMediaList = () =>
  apiInstance({
    url: API_URL_MEDIA,
  });

export default getMediaList;
